/**
 * 敌机射击全局门控（困困·梦境领域 sleepT / 惑惑·混乱力场 confuseT 的实际生效点）。
 *
 * 背景（审计发现）： bosses.js 的 fireTimer 是全仓 ~195 个敌机/boss 发射点共用的
 * 计时器，但它原本不读 mods——sleep/confuse 两个 bomb 曾对正式内容完全无效
 * （只有 fallback 关走 ctx.fireGate），而敌机头顶符号却声称它们睡着了。
 * fireTimer 每个调用点都经 gatedInterval 读这里；gameScene enter 挂接 mods、exit 摘除。
 * node 可直接 import（模块级单例）。
 */
export const modsGate = { mods: null };

/**
 * 按 mods 调整后的实际发射间隔。
 * @param {number} interval 脚本请求的基础间隔（秒）
 * @returns {number} sleepT>0 → Infinity（不射弹）；confuseT>0 → interval×2；否则原样
 */
export function gatedInterval(interval) {
  const m = modsGate.mods;
  if (!m) return interval;
  if (m.sleepT > 0) return Infinity;
  if (m.confuseT > 0) return interval * 2;
  return interval;
}
